// lib
import React from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { CalendarToday, Layers, Place } from "@material-ui/icons";

const displaySemesterAndYear = (semester, year) => {
  if (semester && year) return `${semester} — ${year}`;
  return semester || year;
};

const CourseListContents = ({ course }) => {
  return (
    <List className="course-list">
      {course.rootDisplay && (
        <ListItem>
          <ListItemIcon>
            <Layers />
          </ListItemIcon>
          <ListItemText>{course.rootDisplay}</ListItemText>
        </ListItem>
      )}
      {(course.academicYear || course.semester) && (
        <ListItem>
          <ListItemIcon>
            <CalendarToday />
          </ListItemIcon>
          <ListItemText>
            {displaySemesterAndYear(course.semester, course.academicYear)}
          </ListItemText>
        </ListItem>
      )}
      {course.campus && (
        <ListItem>
          <ListItemIcon>
            <Place />
          </ListItemIcon>
          <ListItemText>{course.campus}</ListItemText>
        </ListItem>
      )}
    </List>
  );
};

CourseListContents.propTypes = {
  // from parent
  course: PropTypes.object.isRequired,
};

export default CourseListContents;
